module.exports = __webpack_public_path__ + "img/saum_zinkgelb_ral1018.967ff8ff.jpg";